import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

// eslint-disable-next-line no-unused-vars
// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  root: {
    marginTop: '0px !important',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

function ClassNames(props) {
  const { onClick, icon, ...rest } = props
  return (
    <IconButton onClick={onClick} classes={props.classes} {...rest}>
      {icon}
    </IconButton>
  )
}

export default withStyles(styles)(ClassNames)
